import { render } from "./RetentionAwards.vue?vue&type=template&id=055d061f&scoped=true"
import script from "./RetentionAwards.vue?vue&type=script&lang=js"
export * from "./RetentionAwards.vue?vue&type=script&lang=js"

import "./RetentionAwards.vue?vue&type=style&index=0&id=055d061f&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d061f"]])

export default __exports__